// extracted by css-extract-rspack-plugin
export default {"FacetOption":"FacetOption-module__FacetOption__KZPg65T","TrailingAction":"FacetOption-module__TrailingAction__AUGodv3","TruncateWrap":"FacetOption-module__TruncateWrap__iNjfzWG"};